var map = {
	"./assets/thewest-digital-hero-cropped.jpg": 871,
	"./assets/thewest-digital-hero-variation-a-cropped.jpg": 872,
	"./assets/thewest-digital-hero-variation-a.jpg": 2981,
	"./assets/thewest-digital-hero-variation-afl50-mobile.jpg": 873,
	"./assets/thewest-digital-hero-variation-afl50.jpg": 2982,
	"./assets/thewest-digital-hero-variation-b-cropped.jpg": 874,
	"./assets/thewest-digital-hero-variation-b.jpg": 2983,
	"./assets/thewest-digital-hero-variation-black-friday-cropped.jpg": 875,
	"./assets/thewest-digital-hero-variation-black-friday.jpg": 2984,
	"./assets/thewest-digital-hero-variation-eofy-mobile.jpg": 876,
	"./assets/thewest-digital-hero-variation-eofy.jpg": 2985,
	"./assets/thewest-digital-hero-variation-experiment2-cropped.jpg": 877,
	"./assets/thewest-digital-hero-variation-experiment2.jpg": 2986,
	"./assets/thewest-digital-hero-variation-summer-of-cricket-mobile.jpg": 878,
	"./assets/thewest-digital-hero-variation-summer-of-cricket.jpg": 2987,
	"./assets/thewest-digital-hero-variation-vanishing-cousins-cropped.jpg": 879,
	"./assets/thewest-digital-hero-variation-vanishing-cousins.jpg": 2988,
	"./assets/thewest-digital-hero.jpg": 2989
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 870;